let submenus = document.querySelectorAll('.menu-item-has-megamenu');

for (const submenu of submenus) {
    submenu.addEventListener('mouseenter', () => {
        let submenuFooter = submenu.querySelector('.mega-menu-container--footer');
        
        let submenuHeight = submenu.querySelector('.mega-menu-columns').clientHeight;
        let menuHeight = submenu.querySelector('.mega-menu-container').clientHeight;
        
        if(submenuHeight > (menuHeight + 30)) {
            submenuFooter.classList.add('scrolled');
        }else {
            submenuFooter.classList.remove('scrolled');
        }
        submenu.querySelector('.mega-menu-container').addEventListener('scroll', () => {
            let scrollTop = submenu.querySelector('.mega-menu-container').scrollTop;
            
            if(submenuHeight > (menuHeight + scrollTop + 30)) {
                submenuFooter.classList.add('scrolled');
            }else {
                submenuFooter.classList.remove('scrolled');
            }
        });
    });
}

window.onload = () => {
    let attachments = document.querySelector('.tigren-attachments');
    console.log(attachments);

    if(attachments){
        if(attachments.childNodes.length == 0) {
            // console.log(attachments.closest('.product--accordion'));
            attachments.closest('.product--accordion').style.display = 'none';
        }
    }
}

window.onload = () => {
    setTimeout(() => {
        let authorDescription = document.querySelector('.author-box-description-container');
        if(authorDescription){
            let authorName = document.querySelector('.author-box-name-container');
            if(authorName){
                authorName.appendChild(authorDescription);
            }
        }
    }, 1500);
}